import React from 'react'
import { useAppSelector } from '../../../../hooks/redux'

import QueueSkeletonV2 from '../../../molecules/QueueSkeletonV2'
import ConversationV2 from '../ConversationV2'

import { selectConvo } from '../../../../slices/convo'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import useListStyles from '../ConversationListV2/styles'

const getRelated = (all, conversation) => {
  return Object.values(all).filter(
    session => session.owner_id === conversation.owner_id
  )
}

const LoadingList = ({ mobile }) => {
  const { loadingIDs } = useAppSelector(selectConvo)

  const { conversations } = useQueueState()

  const listClasses = useListStyles({ mobile })

  return (
    <div className={listClasses.root}>
      {loadingIDs.length === 0
        ? new Array(8).fill(0).map((_, i) => <QueueSkeletonV2 key={i} />)
        : loadingIDs.map((id, i) => {
            if (!(id in conversations)) {
              return <QueueSkeletonV2 key={id} />
            }

            const conversation = conversations[id]
            return (
              <ConversationV2
                key={`${id}-${i}`}
                i={i}
                conversation={conversation}
                related={getRelated(conversations, conversation)}
              />
            )
          })}
    </div>
  )
}

export default LoadingList
